// ============ HEADER SCROLL ============
(function(){
  const header = document.getElementById('header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 30);
    }, {passive:true});
  }
})();

// ============ CAROUSEL CARDS ============
(function(){
  const state = {};
  document.querySelectorAll('[data-carousel-prev]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation(); e.preventDefault();
      const handle = btn.dataset.carouselPrev;
      navigate(handle, -1);
    });
  });
  document.querySelectorAll('[data-carousel-next]').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation(); e.preventDefault();
      const handle = btn.dataset.carouselNext;
      navigate(handle, 1);
    });
  });
  function navigate(handle, dir) {
    const slides = document.querySelector(`[data-slides="${handle}"]`);
    if (!slides) return;
    const total = slides.children.length;
    const cur = state[handle] || 0;
    let next = cur + dir;
    if (next < 0) next = total - 1;
    if (next >= total) next = 0;
    state[handle] = next;
    slides.style.transform = `translateX(-${next * 100}%)`;
    document.querySelectorAll(`[data-dot="${handle}"]`).forEach((d, i) => {
      d.classList.toggle('active', i === next);
    });
  }
  document.querySelectorAll('[data-dot]').forEach(d => {
    d.addEventListener('click', e => {
      e.stopPropagation(); e.preventDefault();
      const handle = d.dataset.dot;
      const idx = parseInt(d.dataset.idx, 10);
      const slides = document.querySelector(`[data-slides="${handle}"]`);
      if (slides) {
        state[handle] = idx;
        slides.style.transform = `translateX(-${idx * 100}%)`;
        document.querySelectorAll(`[data-dot="${handle}"]`).forEach((dd, i) => {
          dd.classList.toggle('active', i === idx);
        });
      }
    });
  });
})();

// ============ FAVS ============
document.querySelectorAll('[data-fav]').forEach(btn => {
  btn.addEventListener('click', e => {
    e.stopPropagation(); e.preventDefault();
    btn.classList.toggle('active');
  });
});

// ============ FILTERS + SORT (client-side) ============
(function(){
  const chips = document.querySelectorAll('.chip');
  const sortEl = document.getElementById('sort');
  let currentFilter = 'all';
  let currentSort = 'featured';

  function apply() {
    const cards = Array.from(document.querySelectorAll('.boat-card'));
    cards.forEach(card => {
      const cat = card.dataset.category || 'family';
      const show = currentFilter === 'all' || cat === currentFilter;
      card.style.display = show ? '' : 'none';
    });
    const counter = document.getElementById('resultsCount');
    if (counter) {
      const visible = cards.filter(c => c.style.display !== 'none').length;
      counter.textContent = visible;
    }
  }

  chips.forEach(c => c.addEventListener('click', () => {
    chips.forEach(x => x.classList.remove('active'));
    c.classList.add('active');
    currentFilter = c.dataset.filter || 'all';
    apply();
  }));
  if (sortEl) sortEl.addEventListener('change', e => { currentSort = e.target.value; apply(); });
})();

// ============ SCROLL REVEAL ============
(function(){
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, {threshold:0.1, rootMargin:'-20px'});
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));
})();

// ============ DEFAULT DATE ============
(function(){
  const dateInput = document.getElementById('f-date');
  if (dateInput && !dateInput.value) {
    const d = new Date(); d.setDate(d.getDate() + 7);
    dateInput.value = d.toISOString().slice(0, 10);
  }
})();

// ============ PRODUCT PAGE: BOOKING + CALENDAR + LIGHTBOX ============
(function(){
  if (!window.WP_PRODUCT) return;
  const P = window.WP_PRODUCT;
  const unavailable = (P.unavailableDates || '').split(',').map(s => s.trim()).filter(Boolean);

  // --- Date status check ---
  const dateInput = document.getElementById('bk-date');
  const statusEl = document.getElementById('dateStatus');
  if (dateInput) {
    dateInput.addEventListener('change', () => {
      const v = dateInput.value;
      if (!v) { statusEl.textContent = ''; return; }
      if (unavailable.includes(v)) {
        statusEl.textContent = '❌ Fecha no disponible. Elige otra.';
        statusEl.className = 'pd__date-status busy';
        dateInput.setCustomValidity('Fecha ocupada');
      } else {
        statusEl.textContent = '✓ Disponible — asegura tu fecha.';
        statusEl.className = 'pd__date-status ok';
        dateInput.setCustomValidity('');
      }
    });
  }

  // --- Submit booking form ---
  const form = document.getElementById('bookingForm');
  if (form) {
    const startTime = Date.now();
    const btn = form.querySelector('button[type="submit"]');
    const errBox = form.querySelector('.pd__booking-error');
    const successBox = document.getElementById('bookingSuccess');
    const btnTxt = btn.textContent;

    form.addEventListener('submit', e => {
      e.preventDefault();
      errBox.classList.remove('show');

      // Anti-bot
      const hp = form.querySelector('input[name=website]');
      if (hp && hp.value.trim() !== '') { console.warn('Honeypot bot'); return; }
      if ((Date.now() - startTime) / 1000 < 3) {
        errBox.textContent = 'Revisa los datos y vuelve a intentar.';
        errBox.classList.add('show'); return;
      }

      const fd = new FormData(form);
      const data = {};
      fd.forEach((v, k) => data[k] = v);

      // Validar phone
      const digits = (data.phone || '').replace(/\D/g, '');
      if (digits.length < 10) {
        errBox.textContent = 'Ingresa un WhatsApp válido con código de país.';
        errBox.classList.add('show'); return;
      }

      btn.disabled = true; btn.textContent = 'Procesando...';

      const variant = form.querySelector('#bk-variant').selectedOptions[0]?.text || data.variant_id;

      // 1) Agregar el producto "Booking Deposit" ($100) al carrito con TODOS los detalles del bote como properties
      // El precio del checkout siempre es $100 — el bote real se reserva via properties
      const depositVariantId = P.depositVariantId || 48604427485419;
      const cartPayload = {
        items: [{
          id: parseInt(depositVariantId, 10),
          quantity: 1,
          properties: {
            'Yacht': data.product_title,
            'Duration': variant,
            'Date': data.date,
            'Time': data.time,
            'Guests': data.guests,
            'Customer Name': data.full_name,
            'Email': data.email,
            'WhatsApp': data.phone,
            'Yacht Product ID': data.product_id,
            'Charter Variant ID': data.variant_id
          }
        }]
      };

      // Primero limpiar el cart para evitar items acumulados de sesiones anteriores
      fetch('/cart/clear.js', {method:'POST', headers:{'Accept':'application/json'}})
      .then(() => fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify(cartPayload)
      }))
      .then(r => r.ok ? r.json() : r.json().then(err => { throw new Error(err.description || 'No se pudo agregar al carrito'); }))
      .then(() => {
        // Ir directo al checkout de Shopify para pagar el abono.
        // NO se abre WhatsApp aquí: el link para coordinar la reserva se envía
        // en el correo de confirmación tras el pago.
        form.style.display = 'none';
        successBox.classList.add('show');
        setTimeout(() => { window.location.href = '/checkout'; }, 600);
      })
      .catch(err => {
        console.error('Cart error:', err);
        errBox.textContent = 'No pudimos procesar la reserva: ' + err.message + '. Intenta de nuevo o escríbenos por WhatsApp.';
        errBox.classList.add('show');
        btn.disabled = false;
        btn.textContent = btnTxt;
      });
    });
  }
})();

// ============ LIGHTBOX ============
let lbIdx = 0;
function openLightbox(idx) {
  if (!window.WP_PRODUCT) return;
  lbIdx = idx;
  showLightbox();
}
function showLightbox() {
  const lb = document.getElementById('lightbox');
  const img = document.getElementById('lightboxImg');
  const counter = document.getElementById('lightboxCounter');
  if (!lb || !img || !window.WP_PRODUCT) return;
  img.src = window.WP_PRODUCT.images[lbIdx];
  counter.textContent = `${lbIdx + 1} / ${window.WP_PRODUCT.images.length}`;
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function closeLightbox() {
  const lb = document.getElementById('lightbox');
  if (lb) lb.classList.remove('open');
  document.body.style.overflow = '';
}
function lightboxNav(dir) {
  if (!window.WP_PRODUCT) return;
  const total = window.WP_PRODUCT.images.length;
  lbIdx = (lbIdx + dir + total) % total;
  showLightbox();
}
document.addEventListener('keydown', e => {
  const lb = document.getElementById('lightbox');
  if (!lb || !lb.classList.contains('open')) return;
  if (e.key === 'Escape') closeLightbox();
  if (e.key === 'ArrowLeft') lightboxNav(-1);
  if (e.key === 'ArrowRight') lightboxNav(1);
});
window.openLightbox = openLightbox;
window.closeLightbox = closeLightbox;
window.lightboxNav = lightboxNav;

// ============ MULTI-IDIOMA ES/EN ============
(function(){
  const KEY = 'wp_lang';
  function setLang(lang) {
    document.documentElement.classList.toggle('lang-en', lang === 'en');
    document.documentElement.lang = lang === 'en' ? 'en' : 'es';
    document.querySelectorAll('[data-set-lang]').forEach(b => {
      b.classList.toggle('active', b.dataset.setLang === lang);
    });
    // Opciones de <select> bilingües (el CSS no puede ocultar spans dentro de <option>)
    document.querySelectorAll('option[data-es]').forEach(o => {
      o.textContent = (lang === 'en' && o.dataset.en) ? o.dataset.en : o.dataset.es;
    });
    // Placeholders bilingües de inputs
    document.querySelectorAll('input[data-es]').forEach(i => {
      i.placeholder = (lang === 'en' && i.dataset.en) ? i.dataset.en : i.dataset.es;
    });
    try { localStorage.setItem(KEY, lang); } catch(e) {}
  }
  // Auto-detect: localStorage > navigator > default ES
  let saved = null;
  try { saved = localStorage.getItem(KEY); } catch(e) {}
  let initial = saved;
  if (!initial) {
    const nav = (navigator.language || 'es').toLowerCase();
    initial = nav.startsWith('en') ? 'en' : 'es';
  }
  setLang(initial);
  // Wire buttons
  document.querySelectorAll('[data-set-lang]').forEach(b => {
    b.addEventListener('click', () => setLang(b.dataset.setLang));
  });
})();
